/* ============================================================
   HOUSEP4RTY Shopify theme — shared behavior:
   product variant selection + AJAX add-to-cart, cart page
   qty/remove, and the header cart-count badge.
   ============================================================ */

(function () {
  "use strict";

  /* ---------- product page ---------- */
  document.querySelectorAll(".piece-shell").forEach(function (shell) {
    var select = shell.querySelector("[data-role='variant-select']");
    if (!select) return; // not a product page

    // The <option> elements ARE the data — id, availability, price, and each
    // option1/2/3 value all come straight from Shopify on this page load.
    // No separately-parsed JSON blob that could drift out of sync with them.
    var optionEls = Array.prototype.slice.call(select.options);
    var numOptions = shell.querySelectorAll(".piece-sizes").length;

    var form = shell.querySelector("[data-role='add-to-cart-form']");
    var groups = shell.querySelectorAll(".piece-sizes");
    var selected = {}; // optionIndex -> value
    var cta = shell.querySelector("[data-role='piece-cta']");
    var ctaLabel = cta ? cta.querySelector(".label") : null;
    var ctaNote = shell.querySelector("[data-role='piece-cta-note']");
    var priceEl = shell.querySelector("[data-role='piece-price']");
    var ctaDefaultText = ctaLabel ? ctaLabel.textContent : "";
    var ctaNoteDefault = ctaNote ? ctaNote.textContent : "";

    function moneyFromCents(cents) {
      return "₹" + (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 0 });
    }

    function findMatchingOption() {
      if (numOptions === 0) return optionEls[0] || null;
      for (var i = 0; i < optionEls.length; i++) {
        var opt = optionEls[i];
        var matchesAll = true;
        for (var idx = 0; idx < numOptions; idx++) {
          var key = "option" + (idx + 1);
          if (selected[idx] === undefined) { matchesAll = false; break; }
          if (opt.dataset[key] !== selected[idx]) { matchesAll = false; break; }
        }
        if (matchesAll) return opt;
      }
      return null;
    }

    function refreshPriceAndCta() {
      var opt = findMatchingOption();
      if (opt) {
        select.value = opt.value; // this is what actually gets submitted as "id"
        var price = parseInt(opt.dataset.price, 10) || 0;
        var available = opt.dataset.available === "true";
        if (priceEl) priceEl.textContent = moneyFromCents(price);
        if (ctaLabel) ctaLabel.textContent = "ADD TO CART — " + moneyFromCents(price);
        if (ctaNote) ctaNote.textContent = available ? ctaNoteDefault : "This size is currently out of stock.";
      }
    }

    groups.forEach(function (group) {
      var pills = group.querySelectorAll(".size-pill");
      var optIndex = parseInt(group.getAttribute("data-option-index"), 10);
      var labelRow = group.previousElementSibling;
      var selectedLabel = labelRow ? labelRow.querySelector("[data-role^='selected-size']") : null;

      pills.forEach(function (pill) {
        pill.addEventListener("click", function () {
          pills.forEach(function (p) { p.classList.remove("selected"); });
          pill.classList.add("selected");
          selected[optIndex] = pill.getAttribute("data-value");
          if (selectedLabel) selectedLabel.textContent = pill.textContent.trim();
          refreshPriceAndCta();
        });
      });
    });

    function showError(message) {
      if (!ctaNote) return;
      ctaNote.textContent = message;
      ctaNote.style.color = "#ff6f6f";
    }
    function clearError() {
      if (!ctaNote) return;
      ctaNote.style.color = "";
      ctaNote.textContent = ctaNoteDefault;
    }

    /* Submit is intercepted to go through /cart/add.js first. Reason: a plain
       native form POST to /cart/add is silent on failure — if Shopify rejects
       the add (out of stock, bad variant id, etc) it just redirects back with
       no visible message in this custom theme, which looks exactly like a
       successful "add" that mysteriously never shows up in the cart. Going
       through the JSON endpoint first lets us show Shopify's real error, and
       on success we navigate to the cart ourselves so there's no ambiguity
       about whether it actually landed. The <form action="/cart/add"> markup
       stays in place as a no-JS fallback. */
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        clearError();

        var allSelected = true;
        groups.forEach(function (group) {
          var optIndex = parseInt(group.getAttribute("data-option-index"), 10);
          var pills = group.querySelectorAll(".size-pill");
          var labelRow = group.previousElementSibling;
          var selectedLabel = labelRow ? labelRow.querySelector("[data-role^='selected-size']") : null;
          if (selected[optIndex] === undefined) {
            allSelected = false;
            pills.forEach(function (p) { p.classList.add("shake"); });
            window.setTimeout(function () { pills.forEach(function (p) { p.classList.remove("shake"); }); }, 420);
            if (selectedLabel) selectedLabel.textContent = "pick one first";
          }
        });
        if (!allSelected) return;

        var opt = findMatchingOption();
        if (!opt || !opt.value) {
          showError("Couldn't match that to a real variant — try a different size.");
          return;
        }
        if (opt.dataset.available !== "true") {
          showError("This size is currently out of stock.");
          return;
        }
        select.value = opt.value; // belt and suspenders for the no-JS <form> fallback

        var qtyValueEl = shell.querySelector("[data-role='qty-value']");
        var qty = qtyValueEl ? parseInt(qtyValueEl.value, 10) || 1 : 1;
        if (ctaLabel) ctaLabel.textContent = "Adding…";

        // Re-read select.value at the moment of fetch (not a cached variable)
        // so this is always exactly what the real <select> currently holds.
        fetch(form.getAttribute("action") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: select.value, quantity: qty })
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            if (!result.ok) {
              var msg = (result.data && (result.data.description || result.data.message)) || "Shopify rejected that add — try again.";
              showError(msg);
              if (ctaLabel) ctaLabel.textContent = ctaDefaultText;
              return;
            }
            // confirmed added — now actually go to the cart
            var returnTo = form.querySelector("input[name='return_to']");
            window.location.href = (returnTo && returnTo.value) || "/cart";
          })
          .catch(function () {
            showError("Network error reaching Shopify's cart — check your connection and try again.");
            if (ctaLabel) ctaLabel.textContent = ctaDefaultText;
          });
      });
    }

    /* ---- thumbnail rail ---- */
    var mainImg = shell.querySelector("[data-role='gallery-main']");
    var thumbs = shell.querySelectorAll(".piece-thumb");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) { t.classList.remove("selected"); });
        thumb.classList.add("selected");
        if (mainImg && thumb.dataset.img) mainImg.setAttribute("src", thumb.dataset.img);
      });
    });

    /* ---- quantity stepper ----
       qty-value is a real <input type="number"> now (not just a display
       span) so typing a number directly always works even if these button
       handlers never fire for some reason — belt and suspenders. */
    var qtyValue = shell.querySelector("[data-role='qty-value']");
    var qtyMinus = shell.querySelector("[data-role='qty-minus']");
    var qtyPlus = shell.querySelector("[data-role='qty-plus']");
    function currentQty() {
      var n = qtyValue ? parseInt(qtyValue.value, 10) : 1;
      return isNaN(n) ? 1 : n;
    }
    function setQty(n) {
      n = Math.max(1, Math.min(10, n));
      if (qtyValue) qtyValue.value = String(n);
    }
    if (qtyMinus) {
      qtyMinus.addEventListener("click", function () {
        setQty(currentQty() - 1);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener("click", function () {
        setQty(currentQty() + 1);
      });
    }
    if (qtyValue) {
      qtyValue.addEventListener("change", function () {
        setQty(currentQty());
      });
    }
  });

  /* ---------- night theme: bokeh city lights + skyline ---------- */
  document.querySelectorAll(".piece-bg-night").forEach(function (bg) {
    if (bg.dataset.populated) return;
    bg.dataset.populated = "true";

    var colors = ["#ffb45c", "#ffd39b", "#ff8a6e", "#e2543f", "#9db3d1"];
    var bokehCount = 16;
    for (var i = 0; i < bokehCount; i++) {
      var dot = document.createElement("span");
      dot.className = "bokeh";
      var size = 3 + Math.random() * 7;
      dot.style.left = Math.random() * 100 + "%";
      dot.style.top = (8 + Math.random() * 55) + "%";
      dot.style.width = size + "px";
      dot.style.height = size + "px";
      var color = colors[Math.floor(Math.random() * colors.length)];
      dot.style.background = color;
      dot.style.boxShadow = "0 0 " + (size * 2.2).toFixed(0) + "px " + color;
      dot.style.opacity = (0.15 + Math.random() * 0.35).toFixed(2);
      bg.appendChild(dot);
    }

    var glow = document.createElement("div");
    glow.className = "glow-top";
    bg.appendChild(glow);

    var skyline = document.createElement("div");
    skyline.className = "skyline";
    var bldgCount = 26;
    for (var b = 0; b < bldgCount; b++) {
      var bldg = document.createElement("div");
      bldg.className = "bldg";
      bldg.style.height = (30 + Math.random() * 70) + "%";
      var winCount = 1 + Math.floor(Math.random() * 3);
      for (var w = 0; w < winCount; w++) {
        var win = document.createElement("span");
        win.className = "win";
        win.style.left = (10 + Math.random() * 70) + "%";
        win.style.top = (15 + Math.random() * 70) + "%";
        bldg.appendChild(win);
      }
      skyline.appendChild(bldg);
    }
    bg.appendChild(skyline);
  });

  /* ---------- cart page: quantity + remove ---------- */
  var cartForm = document.querySelector(".cart-form");
  if (cartForm) {
    cartForm.querySelectorAll("[data-role='cart-qty']").forEach(function (input) {
      input.addEventListener("change", function () {
        var line = parseInt(input.getAttribute("data-line"), 10);
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(function () { window.location.reload(); });
      });
    });
    cartForm.querySelectorAll("[data-role='cart-remove']").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = parseInt(btn.getAttribute("data-line"), 10);
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function () { window.location.reload(); });
      });
    });
  }
})();
